import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const AboutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '50px',
  borderBottom: '2px solid #ccc', // Border bottom for the section
  height: '100vh', // Full viewport height
  scrollSnapAlign: 'start', // Smooth scrolling alignment
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column', // Stack items vertically for small screens
    height: 'auto', // Adjust height for small screens
    padding: '20px',
  },
}));

const AboutText = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingRight: '20px',
  [theme.breakpoints.down('sm')]: {
    paddingRight: '0', // Remove padding for small screens
    textAlign: 'center', // Center-align text for small screens
  },
}));

const AboutLogo = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '20px', // Add spacing below the image for small screens
  [theme.breakpoints.down('sm')]: {
    display: 'none', // Hide the image for small screens
  },
}));

const About = () => {
  return (
    <AboutContainer id="about" style={{backgroundColor: 'grey', color: 'white', height: '50%', marginTop: '50px'}}>
      <AboutLogo>
        <img src="/img/lngpng.png" alt="Logo" style={{ width: '50%', height: 'auto' }} />
      </AboutLogo>
      <AboutText>
        <Typography variant="h4" gutterBottom style={{ borderBottom: '4px solid red', paddingBottom: '10px', width: '100%' }}>
        A propos de nous
        </Typography>
        <Typography variant="body1">
        Le Laboratoire National de la Géologie en abrégé le LNG, 
        est un Etablissement Public Administratif à caractère scientifique et 
        commercial, placé sous la tutelle technique du Ministère des Mines et 
        sous la Tutelle financière du Ministère en charge de l’économie et des Finances. 
        Il est chargé de la mise en œuvre de la politique du Gouvernement dans le domaine 
        de l’analyse des échantillons en matière de recherches minières et géologiques.

        </Typography>
      </AboutText>
    </AboutContainer>
  );
};

export default About;